import ContactCard from "components/ListItemsAndCards/ContactCard/ContactCard.vue"


// Developer note: remove labels from props if it not needed in the component
export default {
    name: "CardListContact",
    components: {
        ContactCard
    },
    props: {
        labels: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        leader: { 
            type: String,
            required: false,
        },
        cardsResult: {
            type: Array,
            required: true,
        }

    },
    setup() {


    }
}